import { Button, ButtonGroup, Icon, TextField, Tooltip } from "@shopify/polaris"
import { ClipboardIcon, InfoIcon, ViewIcon } from "@shopify/polaris-icons"
import classNames from "classnames"
import copy from "copy-to-clipboard"
import { observer } from "mobx-react"
import React, { useState } from "react"
import { Trans, useTranslation } from "react-i18next"

import { DashboardSetupGuideEnum } from "@/enums/dashboard"
import AddTrackingPageModal from "@/pages/Dashboard/components/AddTrackingPageModal"
import StepWrapper from "@/pages/Dashboard/components/QuickSetupGuide/StepWrapper"
import { getShortTrackLink } from "@/pages/TrackingPage/utils"
import stores from "@/stores"
import { openLink } from "@/utils/redirectShopify"
import toast from "@/utils/toast"

import styles from "./index.module.scss"


type IProps = {
  active: boolean
  isDone?: boolean
  toggleCompleted: (status: DashboardSetupGuideEnum, completed: boolean) => Promise<any>
  step: DashboardSetupGuideEnum
  titleClick?: () => void
}

const AddTrackingPage = observer((props: IProps) => {
  const { t } = useTranslation(["dashboard", "common"])
  const [videoModalShow, setVideoModalShow] = useState(false)
  const [addTrackingPageShow, setAddTrackingPageShow] = useState(false)
  const { userInfoSore } = stores
  const { toggleCompleted, step, isDone } = props

  // video信息
  const videoTime = 69
  const videoUrl = "https://cdn.parcelpanel.com/front-end/2023/guide/HowToAddTheTrackingPage.mp4"
  const posterUrl = "https://cdn.parcelpanel.com/front-end/2023/guide/cover.webp"

  const handleDoneStep = () => {
    if (typeof toggleCompleted === "function" && !isDone) {
      toggleCompleted(step, true)
    }
  }

  const shopName = userInfoSore.data.store_name.replace(".myshopify.com", "")

  return (
    <StepWrapper
      {...props}
      title={<div className={"flex gap-1 items-center"}>
        {t("dashboard:AddTrackingPage")}
        <a href="https://docs.parcelpanel.com/shopify/getting-started/add-the-tracking-page/" target={"_blank"} rel="noreferrer">
          <Icon tone={"subdued"} source={InfoIcon} />
        </a>
      </div>}
      type={"svg"}
      mediaNode={<img src="https://cdn.parcelpanel.com/front-end/2025/dashboard/add-tracking-page.svg" alt="" />}
    >
      <Trans ns="dashboard" i18nKey="AddTrackingPageDesc">
        <div className={"flex flex-wrap gap-[var(--p-space-button-group-gap)] items-center my-1"}>
          <div className={classNames(styles.disableInput, "w-[400px] max-w-full")}>
            <TextField
              value={`https://${userInfoSore.data.last_track_url}`}
              disabled
              readOnly
              autoComplete={"off"}
              label={""}
            />
          </div>

          <Tooltip content={t("dashboard:ViewTrackingPage")}>
            <Button icon={ViewIcon} onClick={() => openLink(`https://${userInfoSore.data.last_track_url}`)} />
          </Tooltip>

          <Tooltip content={t("common:CopyLink")}>
            <Button onClick={() => {
              if (userInfoSore.data.last_track_url) {
                copy(getShortTrackLink(userInfoSore.data.last_track_url))
                toast(t("common:CopiedSuccessfully"), 2e3)
              }
            }} icon={ClipboardIcon}
            />
          </Tooltip>
        </div>
      </Trans>

      <div className={"my-[var(--p-space-300)] flex items-center"}>
        <AddTrackingPageModal
          show={addTrackingPageShow}
          onClose={() => setAddTrackingPageShow(false)}
          trackURL={getShortTrackLink(userInfoSore.data.last_track_url)}
        />
        <ButtonGroup>
          <Button onClick={() => setAddTrackingPageShow(true)} variant={!props.isDone ? "primary" : undefined} external>
            {t("dashboard:DashboardEdgeTable.TrackingPage.action")}
          </Button>
          {
            !isDone && <Button external onClick={handleDoneStep} variant="tertiary">
              {t("dashboard:AddTrackingPagePlainButtonText")}
            </Button>
          }
        </ButtonGroup>
      </div>

      {/* <Modal*/}
      {/*  size="large"*/}
      {/*  open={videoModalShow}*/}
      {/*  title={t("dashboard:DashboardEdgeTable.TrackingPage.action")}*/}
      {/*  onClose={() => setVideoModalShow(false)}*/}
      {/* >*/}
      {/*  <video*/}
      {/*    autoPlay*/}
      {/*    controls*/}
      {/*    className={"w-full"}*/}
      {/*    // poster={posterUrl} // 去除海报图，在ios下自动播放会导致黑屏播放*/}
      {/*    src={videoUrl}*/}
      {/*    preload="auto"*/}
      {/*  />*/}
      {/* </Modal>*/}
    </StepWrapper>
  )
})

export default AddTrackingPage

